import React from 'react';

// Canonical Card per shared-docs/dark-mode.md.
export default function Card({ children, className = '', ...rest }) {
  return (
    <div
      className={[
        'bg-white rounded-xl shadow-sm border border-gray-100 p-4',
        'dark:bg-night-surface dark:border-night-card',
        className,
      ].join(' ')}
      {...rest}
    >
      {children}
    </div>
  );
}
